import { Inject, Injectable } from '@angular/core';

import type { ApiClient } from '@packages/shared-utils';
import { API_CLIENT } from './api-client.provider';

export type AttachmentRow = {
  id: string;
  conversation_id: string;
  message_id: string | null;
  uploaded_by_user_id: string;
  bucket: string;
  path: string;
  original_filename: string;
  mime_type: string;
  size_bytes: number;
  created_at: string;
};

@Injectable({ providedIn: 'root' })
export class AttachmentsApiService {
  constructor(@Inject(API_CLIENT) private readonly api: ApiClient) {}

  async uploadToConversation(
    conversationId: string,
    file: File,
  ): Promise<AttachmentRow> {
    const form = new FormData();
    form.append('file', file, file.name);

    const res = await this.api.postFormData<{ attachment: AttachmentRow }>(
      `/conversations/${encodeURIComponent(conversationId)}/attachments`,
      form,
    );
    return res.attachment;
  }
}